<template>
  <main class="main album" v-if="record">
    <section class="player">
      <album-player :user="user" :songs="record.songs" :activeIndex="activeSongIndex"></album-player>
    </section>

    <section class="module narrow album-details">
  		<article class="max-width	side-padding">
        <div class="title-block">
		      <h1 class="xxl regular">{{record.artist.name}}</h1>
		      <h2 class="xxl light">{{record.title}}</h2>
        </div>
      
      	<div class="img-block">
		      <div class="skewed">
            <div class="box skew">
              <div class="front">
                <img v-if="record.cover.path" :src="record.cover.path" />
	    		      <img v-else src="/themes/caramba/assets/images/album.jpg" />
              </div>
      		    <div class="back"></div>
              <div class="right"></div>
              <div class="left"></div>
              <div class="top"></div>
              <div class="bottom"></div>
            </div>
		      </div>	
	      </div>

        <album-tracklist :songs="record.songs" @song:update="updateActiveSong" :activeIndex="activeSongIndex" :highlightedIndexes="highlightedIndexes"></album-tracklist>
  		</article>

      <div class="centered clear" v-if="record.fonola_link != ''">
        <a :href="record.fonola_link" target="_blank" rel="external noopener nofollow" class="button button-big button-azure">Disponibile per il digitale</a>
      </div>
    </section>
      
    <album-same-author :record="record"></album-same-author>
    <album-same-repertorio :record="record"></album-same-repertorio>
    <album-banner></album-banner>
    
  </main>
</template>

<script>
import axios from 'axios/dist/axios';
import AlbumPlayer from './AlbumPlayer.vue';
import AlbumTracklist from './AlbumTracklist.vue';
import AlbumSameAuthor from './AlbumSameAuthor.vue';
import AlbumSameRepertorio from './AlbumSameRepertorio.vue';
import AlbumBanner from './AlbumBanner.vue';

export default {
  props: ['user'],
  data() {
    return {
      record: undefined,
      activeSongIndex: 1,
      highlightedIndexes: []
    }
  },

  mounted() {
    this.update();

    //const setPlayer
  },

  beforeDestroy() {
    //window.removeEventListener('scroll', , false);
  },

  watch: {
    '$route' (to, from) {
      this.update();
    }
  },

  methods: {
    updateActiveSong: function(i) {
      this.activeSongIndex = i;
    },

    update: function() {
      axios.get(window.location.origin + '/api/v1/album/get/' + this.$route.params.album)
      .then(resp => {
        this.record = resp.data[0];

        document.title = 'Caramba - Album:' + this.record.title + ' di ' + this.record.artist.name;
        
        const genreId = this.$route.query.genre && +this.$route.query.genre;
        const songSlug = this.$route.query.song;
        const highlightType = genreId ? 'genre': (songSlug ? 'song': null);

        if(highlightType != null) {
          this.record.songs = this.record.songs.map((song, songIndex) => {
            if(highlightType == 'genre') {
              if(genreId == song.genre_id) {
                this.highlightedIndexes.push(songIndex);
              } 
            } else
            if(highlightType == 'song') {
              if(songSlug == song.slug) {
                this.highlightedIndexes.push(songIndex);
              }
            }
            return song;
          });
        }

        if(this.highlightedIndexes.length) {
          this.activeSongIndex = this.highlightedIndexes[0] + 1;
        }
      });
    }
  },

  components: {
    'album-player': AlbumPlayer,
    'album-tracklist': AlbumTracklist,
    'album-same-author': AlbumSameAuthor,
    'album-same-repertorio': AlbumSameRepertorio,
    'album-banner': AlbumBanner
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/vue/components/Album.vue